import React from "react";
import "./Navigation.scss";
import {AnyElementType} from "@data-force/app";
import {connect} from "react-redux";
import {Steps} from "antd";
import StoreState from "../../interfaces/store/storeState";
import {setNavigationSelection} from "../../store/actions/layout";
import {SetNavigationSelectionAction} from "../../interfaces/store/actions/layout";

interface StateProps {
    navigationElements: AnyElementType[]
    navigationSelection: number
}

interface DispatchProps {
    setNavigationSelection(payload: number): SetNavigationSelectionAction
}

type Props = StateProps & DispatchProps;

class Navigation extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.navigationChangeHandler = this.navigationChangeHandler.bind(this);
    }

    navigationChangeHandler(current: number) {
        this.props.setNavigationSelection(current);

        const {fieldName}: AnyElementType = this.props.navigationElements[current];
        const titleElement = document.getElementById(`df-chapter-${fieldName}`);
        if (titleElement) {
            titleElement.scrollIntoView({behavior: "smooth"});
        }
    }

    render(): React.ReactElement {
        const {navigationElements, navigationSelection}: Props = this.props;
        return (
            <div className="df-navigation-section">
                <Steps
                    current={navigationSelection}
                    direction="vertical"
                    onChange={this.navigationChangeHandler}
                >
                    {
                        navigationElements.map(({label, fieldName}: AnyElementType): React.ReactElement => (
                            <Steps.Step title={label} key={fieldName}/>
                        ))
                    }
                </Steps>
            </div>
        );
    }
}

function mapStateToProps(state: StoreState): StateProps {
    return {
        navigationElements: state.layout.content.navigation.elements,
        navigationSelection: state.layout.content.navigation.selection,
    };
}

const mapDispatchToProps: DispatchProps = {
    setNavigationSelection,
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
